import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import VideoPlayerSection from './VideoPlayerSection';
import VideoMetaSection from './VideoMetaSection';
import TimelineSection from './TimelineSection';
import '../../../../../../resources/assets/styles/videoInfo.scss';

function VideoInfoTab() {
    const [videoDurationTime, setVideoDurationTime] = useState(0);

    return (
        <div className="video-info-tab__container">
            <div className="video-info-tab__wrapper">
                <VideoPlayerSection setVideoDurationTime={setVideoDurationTime} />
                <VideoMetaSection videoDurationTime={videoDurationTime} />
            </div>
            <TimelineSection videoDurationTime={videoDurationTime} />
        </div>
    );
}

export default VideoInfoTab;
